import React from 'react'
import { FaIcon, faTrash } from '@/lib/fa'
import { MoneyInput } from './MoneyInput'
import { CountryInput } from './CountryInput'
import { useBusinessTripRatesTableContext } from '../context/BusinessTripRatesTableContext'
import styles from './styles.module.scss'
import { useBusinessTripRatesRowContext } from '../context/BusinessTripRatesRowContext'
import { DateInput } from './DateInput'

export const BusinessTripRatesTableRow = () => {
  const {
    savedRates,
    availableCountries,
    availableCurrencies,
    handleUpdate,
    handleDelete,
  } = useBusinessTripRatesTableContext()
  const { rate } = useBusinessTripRatesRowContext()

  const handleMoneyValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    handleUpdate(rate.id, { [name]: Number(value) })
  }

  const handleCurrencyChange = (name: string, code: string) => {
    const curr = availableCurrencies.find((c) => c.code === code)
    if (curr) handleUpdate(rate.id, { [name]: curr })
  }

  const handleChangeCountry = (code: string) => {
    const cntr = availableCountries.find((c) => c.code === code)
    if (cntr) handleUpdate(rate.id, { country: cntr })
  }

  return (
    <tr>
      <td className={styles.colCountry}>
        <CountryInput
          value={rate.country}
          availableCountries={availableCountries}
          handleChange={handleChangeCountry}
        />
      </td>

      <td className={styles.colDate}>
        <DateInput name="dateFrom" />
      </td>

      <td className={styles.colDate}>
        <DateInput name="dateTo" />
      </td>

      <td className={styles.colMoney}>
        <MoneyInput
          value={rate.allowanceRate}
          currency={rate.allowanceCurrency}
          name="allowanceRate"
          currencyName="allowanceCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </td>

      <td className={styles.colMoney}>
        <MoneyInput
          value={rate.allowanceAccomodationRate}
          currency={rate.allowanceAccomodationCurrency}
          name="allowanceAccomodationRate"
          currencyName="allowanceAccomodationCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </td>

      <td className={styles.colMoney}>
        <MoneyInput
          value={rate.allowanceSanitarityRate}
          currency={rate.allowanceSanitarityCurrency}
          name="allowanceSanitarityRate"
          currencyName="allowanceSanitarityCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </td>

      <td className={styles.colMoney}>
        <MoneyInput
          value={rate.allowanceHotelLimitationRate}
          currency={rate.allowanceHotelLimitationCurrency}
          name="allowanceHotelLimitationRate"
          currencyName="allowanceHotelLimitationCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </td>

      <td
        className={styles.colActions}
        onClick={() => handleDelete(rate.id)}
      >
        <FaIcon
          icon={faTrash}
          className="tw-cursor-pointer hover:tw-text-red-600"
        />
      </td>
    </tr>
  )
}
